import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart } from 'recharts';
const LeadGenerationTrend: React.FC = () => {
  const data = [{
    period: 'Week 1',
    leads: 285,
    qualified: 195,
    converted: 46,
    rate: 16.1
  }, {
    period: 'Week 2',
    leads: 310,
    qualified: 215,
    converted: 52,
    rate: 16.8
  }, {
    period: 'Week 3',
    leads: 295,
    qualified: 205,
    converted: 48,
    rate: 16.3
  }, {
    period: 'Week 4',
    leads: 320,
    qualified: 225,
    converted: 54,
    rate: 16.9
  }, {
    period: 'Week 5',
    leads: 305,
    qualified: 210,
    converted: 50,
    rate: 16.4
  }, {
    period: 'Week 6',
    leads: 335,
    qualified: 240,
    converted: 58,
    rate: 17.3
  }, {
    period: 'Week 7',
    leads: 315,
    qualified: 220,
    converted: 52,
    rate: 16.5
  }, {
    period: 'Week 8',
    leads: 340,
    qualified: 245,
    converted: 60,
    rate: 17.6
  }, {
    period: 'Week 9',
    leads: 325,
    qualified: 230,
    converted: 55,
    rate: 16.9
  }, {
    period: 'Week 10',
    leads: 350,
    qualified: 255,
    converted: 63,
    rate: 18.0
  }, {
    period: 'Week 11',
    leads: 330,
    qualified: 235,
    converted: 57,
    rate: 17.3
  }, {
    period: 'Week 12',
    leads: 360,
    qualified: 265,
    converted: 66,
    rate: 18.3
  }];
  const last30Days = data.slice(-4);
  const last60Days = data.slice(-8);
  const last90Days = data;
  const calculateMetrics = (dataset: typeof data) => {
    const totalLeads = dataset.reduce((sum, d) => sum + d.leads, 0);
    const totalConverted = dataset.reduce((sum, d) => sum + d.converted, 0);
    const avgRate = totalConverted / totalLeads * 100;
    return {
      totalLeads,
      totalConverted,
      avgRate
    };
  };
  const metrics30 = calculateMetrics(last30Days);
  const metrics60 = calculateMetrics(last60Days);
  const metrics90 = calculateMetrics(last90Days);
  return <Card className="p-6 mb-8" data-id="element-7713">
      <div className="flex items-center justify-between mb-4" data-id="element-7714">
        <div data-id="element-7715">
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-7716">
            Lead Generation Trend
          </h3>
          <p className="text-sm text-gray-600" data-id="element-7717">
            Weekly performance over 90 days
          </p>
        </div>
        <div className="flex items-center space-x-4 text-sm" data-id="element-7718">
          <div className="text-center px-4 py-2 bg-blue-50 rounded-lg" data-id="element-7719">
            <div className="text-xs text-gray-600" data-id="element-7720">30 Days</div>
            <div className="text-lg font-bold text-blue-600" data-id="element-7721">
              {metrics30.totalLeads}
            </div>
            <div className="text-xs text-gray-600" data-id="element-7722">
              {metrics30.avgRate.toFixed(1)}% conv
            </div>
          </div>
          <div className="text-center px-4 py-2 bg-green-50 rounded-lg" data-id="element-7723">
            <div className="text-xs text-gray-600" data-id="element-7724">60 Days</div>
            <div className="text-lg font-bold text-green-600" data-id="element-7725">
              {metrics60.totalLeads}
            </div>
            <div className="text-xs text-gray-600" data-id="element-7726">
              {metrics60.avgRate.toFixed(1)}% conv
            </div>
          </div>
          <div className="text-center px-4 py-2 bg-purple-50 rounded-lg" data-id="element-7727">
            <div className="text-xs text-gray-600" data-id="element-7728">90 Days</div>
            <div className="text-lg font-bold text-purple-600" data-id="element-7729">
              {metrics90.totalLeads}
            </div>
            <div className="text-xs text-gray-600" data-id="element-7730">
              {metrics90.avgRate.toFixed(1)}% conv
            </div>
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350} data-id="element-7731">
        <ComposedChart data={data} data-id="element-7732">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7733" />
          <XAxis dataKey="period" tick={{
          fontSize: 11
        }} angle={-45} textAnchor="end" height={80} data-id="element-7734" />
          <YAxis yAxisId="left" tick={{
          fontSize: 12
        }} data-id="element-7735" />
          <YAxis yAxisId="right" orientation="right" tick={{
          fontSize: 12
        }} data-id="element-7736" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} data-id="element-7737" />
          <Legend data-id="element-7738" />
          <Bar yAxisId="left" dataKey="leads" fill="#3b82f6" name="Total Leads" data-id="element-7739" />
          <Bar yAxisId="left" dataKey="qualified" fill="#10b981" name="Qualified Leads" data-id="element-7740" />
          <Bar yAxisId="left" dataKey="converted" fill="#8b5cf6" name="Converted" data-id="element-7741" />
          <Line yAxisId="right" type="monotone" dataKey="rate" stroke="#ef4444" strokeWidth={3} name="Conversion Rate %" dot={{
          r: 4
        }} data-id="element-7742" />
        </ComposedChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7743">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-7744">
          <div className="text-center" data-id="element-7745">
            <div className="text-gray-600" data-id="element-7746">Total Leads (90d)</div>
            <div className="text-xl font-bold text-gray-900" data-id="element-7747">
              {metrics90.totalLeads.toLocaleString()}
            </div>
          </div>
          <div className="text-center" data-id="element-7748">
            <div className="text-gray-600" data-id="element-7749">Qualified (90d)</div>
            <div className="text-xl font-bold text-green-600" data-id="element-7750">
              {last90Days.reduce((sum, d) => sum + d.qualified, 0).toLocaleString()}
            </div>
          </div>
          <div className="text-center" data-id="element-7751">
            <div className="text-gray-600" data-id="element-7752">Converted (90d)</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-7753">
              {metrics90.totalConverted}
            </div>
          </div>
          <div className="text-center" data-id="element-7754">
            <div className="text-gray-600" data-id="element-7755">Avg Conversion</div>
            <div className="text-xl font-bold text-red-600" data-id="element-7756">
              {metrics90.avgRate.toFixed(1)}%
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default LeadGenerationTrend;